import React from "react";
import { Link } from "react-router-dom";

//import components
import SidebarContent from "./SidebarContent";

//import images
import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

const Sidebar = (props: any) => {
  // Add a function to check if body has the vertical-collapsed class
  const isBodyCollapsed = () => {
    console.log("isCollapsed", document.body.classList.contains('vertical-collpsed'));
    return document.body.classList.contains('vertical-collpsed');
  };

  // Add state to track collapsed status
  const [isCollapsed, setIsCollapsed] = React.useState(isBodyCollapsed());

  // Add effect to update state when body class changes
  React.useEffect(() => {
    const handleClassChange = () => {

      console.log(isBodyCollapsed());
      setIsCollapsed(isBodyCollapsed());
    };

    // Initial check
    handleClassChange();

    // Set up mutation observer to watch for class changes on body
    const observer = new MutationObserver(handleClassChange);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box mt-3">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light d-flex align-items-center justify-content-center">
            <span className="logo-sm">
              <img src={logo} alt="" height="39" />
            </span>
            {!isCollapsed ? (
              <span className="logo-lg d-flex align-items-center justify-content-center">
                <img src={logoLightPng} alt="" height="60" />
              </span>
            ) : null}
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;